import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {
  CREATE_OFFER_RESERVATION,
  FORGET_PASSWORD,
  RESET_PASSWORD,
} from './../graphql/mutations/mutations';
import {
  ForgetPasswordInput,
  successPayload,
  ResetUserPasswordInput,
  CreateOfferReservationInput,
} from './../graphql/types/types';
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { BehaviorSubject } from 'rxjs';
import { SIGN_IN, SIGN_UP } from '../graphql/mutations/mutations';

const AUTH_API = 'https://app.amandamed.com';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  loginDialog = new BehaviorSubject<boolean>(false);
  constructor(private apollo: Apollo, private http: HttpClient) {}

  signUpParamters() {
    return this.http.get(
      `https://amc.amandamed.com/patient_get_signup_parameter?api_type=website&token=Asd@654321`
    );
  }

  signUp(obj: any, urlOp: string) {
    return this.http.get(
      `${AUTH_API}:${urlOp}/patient_signup?name=${obj.name}&national_number=${obj.national_number}&password=${obj.password}&confirm_password=${obj.confirm_password}&phone=${obj.phone}&email=${obj.email}&doctor_p_id=${obj.doctor_p_id}&sex_p=${obj.sex_p}&marital_status_p=${obj.marital_status_p}&patient_source_p_id=${obj.patient_source_p_id}&country_id=${obj.country_id}&dob_p=${obj.dob_p}&lang=ar&api_type=website&api_token=Asd@654321`,
      {}
    );
  }

  login(obj: any) {
    return this.http.get(
      `https://amc.amandamed.com/patient_login?login=${obj.login}&password=${obj.password}&api_type=website&api_token=Asd@654321`
    );
  }

  gSignUp(Obj: any) {
    return this.apollo.mutate<any>({
      mutation: SIGN_UP,
      variables: { userSignUpDetailsInput: Obj },
    });
  }

  gLogIn(Obj: any) {
    return this.apollo.mutate<any>({
      mutation: SIGN_IN,
      variables: { authCredentialInput: Obj },
    });
  }

  showLoginDialog() {
    this.loginDialog.next(true);
  }

  hideLoginDialog() {
    this.loginDialog.next(false);
  }

  forgetPassword(Obj: ForgetPasswordInput) {
    return this.apollo.mutate<successPayload>({
      mutation: FORGET_PASSWORD,
      variables: { forgetPasswordInput: Obj },
    });
  }

  resetPassword(Obj: ResetUserPasswordInput) {
    return this.apollo.mutate<successPayload>({
      mutation: RESET_PASSWORD,
      variables: { resetUserPasswordInput: Obj },
    });
  }

  applyOnForm(Obj: CreateOfferReservationInput) {
    return this.apollo.mutate<successPayload>({
      mutation: CREATE_OFFER_RESERVATION,
      variables: { createOfferReservationInput: Obj },
    });
  }
}
